module.exports = __webpack_public_path__ + "img/step-4.f7687c1f.png";